import { registerShapeFactory } from '../base';
var SchemaShapeFactory = registerShapeFactory('schema', {
    defaultShapeType: '',
});
export default SchemaShapeFactory;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2@4.0.15@@antv/g2/esm/geometry/shape/schema/index.js
// module id = null
// module chunks = 